/** Használati statisztika — a felhasználó oldala (rendszerterv 9.1; tájékoztató 4.16). */
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "./client";
import { ME_KEY, type User } from "./auth";

export const USAGE_STATUS_KEY = ["usage", "status"] as const;

/** Rögzít-e most a szerver ettől a felhasználótól (el van-e indítva, és nem kapcsolta-e ki). */
export function useUsageStatus(enabled: boolean) {
  return useQuery({
    queryKey: USAGE_STATUS_KEY,
    queryFn: () => api<{ active: boolean }>("/usage/status"),
    enabled,
    staleTime: 10 * 60 * 1000,
  });
}

/** A profil „Használati statisztika” kapcsolója; kikapcsolva a korábbi adatok is törlődnek. */
export function useSetUsagePreference() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (enabled: boolean) => api<User>("/usage/preference", { method: "PUT", body: { enabled } }),
    onSuccess: (user) => {
      qc.setQueryData(ME_KEY, user);
      void qc.invalidateQueries({ queryKey: USAGE_STATUS_KEY });
    },
  });
}
